
import { db } from '../../src/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import brandData from '../../brand_name_database.json';
import type { AuditReport } from '../../types/audit';
import { calculateBrandScore } from './scoringService';

export const generateAuditReport = async (name: string, industry: string, userId?: string): Promise<AuditReport> => {
  // Use the new deterministic engine
  const result = calculateBrandScore(name, industry);

  // Firestore compatibility wrapper
  const report: AuditReport = {
    ...result,
    userId
  };

  // Persist to Firestore if user is authenticated
  if (userId) {
    try {
      const auditsRef = collection(db, 'users', userId, 'audits');
      await addDoc(auditsRef, {
        ...report,
        createdAt: serverTimestamp()
      });
    } catch (e) {
      console.error("Failed to auto-save audit:", e);
    }
  }

  return report;
};

export const getIndustriesList = (): string[] => {
  return Object.keys(brandData.industries).sort();
};
